import React from "react";
import classes from "./PartnerCountry.module.scss";
import HeroSection from "./HeroSection/HeroSection";
import Tieups from "./Tieups/Tieups";
import ProductFeatures from "./ProductFeatures/ProductFeatures";
import WhyKc from "./WhyKc/WhyKc";
import Testimonies from "./Testimonies/Testimonies";
import HowToBecomePartner from "./HowToBecomePartner/HowToBecomePartner";
import ConnectWithTeam from "./ConnectWithTeam/ConnectWithTeam";
import DownloadCoursefinder from "./DownloadCoursefinder/DownloadCoursefinder";
import FAQs from "../AlliedServices/FAQs/FAQs";

const PartnerCountry = ({ partnerCountryData }: any) => {
  return (
    <main className={classes["partner-country-section"]}>
      {partnerCountryData?.heroSection && <HeroSection partnerCountryData={partnerCountryData} />}
      {partnerCountryData?.tieups && <Tieups tieupsData={partnerCountryData?.tieups} />}
      {partnerCountryData?.coursefinderFeatures && <ProductFeatures productFeaturesData={partnerCountryData?.coursefinderFeatures} />}
      {partnerCountryData?.whyKc && <WhyKc whyKcData={partnerCountryData?.whyKc} />}
      {partnerCountryData?.testimonies && <Testimonies testimoniesData={partnerCountryData?.testimonies} />}
      {partnerCountryData?.howToBecomePartner && <HowToBecomePartner howToBecomePartnerData={partnerCountryData?.howToBecomePartner} />}
      {partnerCountryData?.connectWithTeam && <ConnectWithTeam connectWithTeamData={partnerCountryData?.connectWithTeam} />}
      {partnerCountryData?.faq && (
        <div className={classes["faq-section-wrapper"]}>
          <FAQs faqData={partnerCountryData?.faq} />
        </div>
      )}
      {partnerCountryData?.downloadCoursefinder && <DownloadCoursefinder downloadCoursefinderData={partnerCountryData?.downloadCoursefinder} />}
    </main>
  );
};

export default PartnerCountry;
